import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel from 'eco-design/sections/eco-section-carousel';
import { useRouter } from 'next/router';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.ListA');
    const { locale } = useRouter();
    const comfort4Map = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744703819807/comfort_4_us.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744704765055/comfort_4_us_h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744703925767/comfort_4_ca.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744704763919/comfort_4_ca_h5.jpg',
        },
    };
    const itemsA = [
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744441651468/comfort_1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744441651468/comfort_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441739472/comfort_1_h5.jpg',
            title: '',
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744441651641/comfort_2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744441651641/comfort_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441740229/comfort_2_h5.jpg',

            title: '',
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744441652026/comfort_3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744441652026/comfort_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441739343/comfort_3_h5.jpg',

            title: '',
        },
        {
            desc: '',
            icon: '',
            pc: comfort4Map[locale as keyof typeof comfort4Map]?.pc || comfort4Map.ca.pc,
            pad: comfort4Map[locale as keyof typeof comfort4Map]?.h5 || comfort4Map.ca.h5,
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441739679/comfort_4_h5.jpg',

            title: '',
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744441651850/comfort_5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744441651850/comfort_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441739841/comfort_5_h5.jpg',

            title: '',
        },
        {
            desc: '',
            icon: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744441652228/comfort_6.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744441652228/comfort_6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744441740032/comfort_6_h5.jpg',

            title: '',
        },
    ];
    return (
        <div className={`${styles.comp}`}>
            <EcoSpace />
            <EcoSectionCarousel label={t('label')} labelColor="#FFA400" title={t('title')} items={itemsA} />
            <EcoSpace />
        </div>
    );
}
